import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, CTA_LABEL, OFFER_ANCHOR } from '../utils/checkout';
interface CTAButtonProps {
  className?: string;
  /** Only the pricing card overrides the label. Everywhere else uses the single shared CTA. */
  label?: string;
  /** Pins the arrow to the right edge so a two-line label stays centered (used in the hero). */
  pinArrow?: boolean;
  /** 'offer' scrolls to the pricing section, 'checkout' opens the checkout page. */
  target?: 'offer' | 'checkout';
}
export function CTAButton({
  className = '',
  label = CTA_LABEL,
  pinArrow = false,
  target = 'offer'
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : OFFER_ANCHOR} className={`${pinArrow ? 'relative px-14' : 'gap-2.5 px-8'} inline-flex min-h-[58px] items-center justify-center rounded-full bg-amber py-4 text-center font-display text-sm font-bold uppercase leading-tight tracking-wide text-white shadow-card transition-[background-color,transform,box-shadow] duration-200 ease-out hover:-translate-y-0.5 hover:bg-[#F59200] hover:shadow-lift focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pine focus-visible:ring-offset-2 md:text-base ${className}`} data-id="element-54" data-mp="33r8st8clufol">
      {label}
      <ArrowRightIcon className={`${pinArrow ? 'absolute right-6' : ''} h-4 w-4 shrink-0`} aria-hidden="true" data-id="element-55" data-mp="1n8o2xmb8jkoe" />
    </a>;
}